import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';
import {Basket} from './basket';

export class Order {

    static _JSONProps: string[] = [
        'id'
    ];

    id: string;
    basket: Basket = null;

    constructor(initializer?: OrderJSON) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: OrderJSON | string | Order): Order {
        if (json === null) {
            return new Order();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, Order.reviver);
        } else {
            const task = Object.create(Order.prototype);

            const extra = {basket: null};

            Object.keys(json).forEach((key, index) => {
                if (Order._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }

                if (key === 'basket') {
                    extra.basket = Basket.fromJSON(json[key]);
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === '' ? Order.fromJSON(value) : value;
    }

    public formattedDate(field: string, format: string) {
        if (this[field]) {
            const thisField: Moment = this[field];
            if (thisField.isValid()) {
                return this[field].format(format);
            }
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface OrderJSON {
    id?: number;
    task_id: number;
    customer_id: number;
    user_id: number;
    description: string;
    completed: boolean;
    date;
    start_time?;
    stop_time?;
}
